import { render } from "./InstallmentsDetails.vue?vue&type=template&id=5a6a598f"
import script from "./InstallmentsDetails.vue?vue&type=script&lang=js"
export * from "./InstallmentsDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__